import { createColumnHelper } from "@tanstack/react-table";
import editIcon from "../../../assets/images/editIcon.svg";
import eyeIcon from "../../../assets/images/eye.svg";
import TrfVerify from "../../../assets/images/TrfVerify.svg";
import NotVerifyIcon from "../../../assets/images/NotVerifyIcon.svg";
import pendingIcon from "../../../assets/images/pendingsymbol.svg";
import deleteIcon from "../../../assets/images/trash.svg";
import placeOrderIcon from "../../../assets/images/Order-place.svg";
import linkIcon from "../../../assets/images/link.svg";
import unlinkIcon from "../../../assets/images/unlink.svg";
import xIcon from "../../../assets/images/xmark.svg";
import reasonIcon from "../../../assets/images/reason.svg";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import DeclineModalComponent from "../../../components/Modals/DeclineModalComponent";
import ReasonModalComponent from "../../../components/Modals/ReasonModalComponent";
import { useState } from "react";
import NotVerifyModalComponent from "../../../components/Modals/NotVerifyModalComponent";
import FileOutlineIcon from '@mui/icons-material/Description';
import { getDate } from "../../../helpers/helperFunction";
import { confirmAlert } from "../../../components/customeAlert/confirm-alert";
import * as message from "../../../components/Commons/messages/messages";
import Tooltip from "@mui/material/Tooltip"; // Assuming you are using Material-UI for tooltips

const role = ["br", "gr", "ffm"];

const columnHelper = createColumnHelper();
// const userDetails = useSelector(state => state.auth.userDetails) || {}
// const columnDefDefaultFn = (navigateCallback, isCancelModalOpen, t) => [
//   {
//     accessorKey: "orderNumber",
//     header: t("OrdersTableText.purchaseOrder"),
//   },
//   columnHelper.accessor(
//     (row) => {
//       // console.log("Test row", row);
//       return row.buyerCompany ? row.buyerCompany.companyName : "N/A";
//     },
//     {
//       id: "buyerCompany", // Custom ID for the column
//       header: t("OrdersTableText.buyer"),
//     }
//   ),
//   columnHelper.accessor(
//     (row) => {
//       return row.supplierCompany ? row.supplierCompany.companyName : "N/A";
//     },
//     {
//       id: "supplierCompanyName", // Custom ID for the column
//       header: t("OrdersTableText.Supplier"),
//     }
//   ),
//   columnHelper.accessor(row => {
//     return row.orderDate ? getDate(row.orderDate) : "";
//   },
//   {
//     id: "orderDate",
//     header: t("OrdersTableText.orderDate"),
//     // cell: lastNameCellFn
//   }),
//   {
//     accessorKey: "orderDescription",
//     header: t("OrdersTableText.orderDescription"),
//     // filterFn: firstNameFilterFn
//   },
//   {
//     accessorKey: "orderStatus",
//     header: t("OrdersTableText.orderStatus"),
//     enableColumnFilter: false,
//     cell: ({ row }) => {
//       let statusClass = "";
//       switch (row.original.orderStatus) {
//         case "Placed":
//           statusClass = "bg-placed";
//           break;
//         case "Cancelled":
//           statusClass = "bg-cancelled";
//           break;
//         case "Open":
//           statusClass = "bg-open";
//           break;
//         case "Fulfilled":
//           statusClass = "bg-fulfilled";
//           break;
//         case "Partially Fulfilled":
//           statusClass = "bg-fulfilled";
//           break;
//         case "Pending":
//           statusClass = "bg-pending";
//           break;
//         // Add more cases as needed for other status values
//         default:
//           statusClass = "";
//       }

//       return (
//         <span className={`badge ${statusClass}`}>
//           {row.original.orderStatus}
//         </span>
//       );
//     },
//   },
//   {
//     accessorKey: "isOrderPlaced",
//     header: t("OrdersTableText.orderChecklist"),
//     cell: ({ row }) => (
//       // <button onClick={() => navigateCallback(row.original.id)}>
//       //     Go to Details
//       // </button>
//       <div className="d-flex clays-sm">
//         <button className="icon-clay">
//           {/* <span className="inner-clay color-green"><i className="bi bi-pencil-square"><img src={pendingIcon} alt="pending"/></i></span> */}
//           <span className="inner-clay color-green">
//             <img src={pendingIcon} alt="pending" />
//           </span>
//         </button>
//       </div>
//     ),
//   },
//   {
//     accessorKey: "action",
//     header: t("OrdersTableText.Action"),
//     cell: ({ row }) => {
//       // <button onClick={() => navigateCallback(row.original.orderId)}>
//       //     Go to Details
//       // </button>
//       const orderRowData = row.original;
//       return (
//         <div className="d-flex clays-sm">
//           <button
//             className="icon-clay"
//             onClick={() => navigateCallback(orderRowData.orderId)}
//             title="View Order"
//           >
//             {/* <span className="inner-clay color-black"><i className="bi bi-eye"><img src={eyeIcon} alt="View"/></i></span> */}
//             <span className="inner-clay color-black">
//               <img src={eyeIcon} alt="View" />
//             </span>
//           </button>
//           {orderRowData.isOrderPlaced === 1 &&
//             orderRowData.isCancelled !== 1 &&
//             orderRowData.orderStatus !== "Fulfilled" && (
//               <DeclineModalComponent
//                 isOpen={isCancelModalOpen}
//                 onClose={() => onClose}
//                 orderId={row.original.orderId}
//                 forModule="Order"
//               />
//             )}
//           {/* <button className="icon-clay">
//           <span className="inner-clay color-red"><img src={xIcon} alt="Delete" /></span>
//         </button>*/}
//         </div>
//       );
//     },
//   },
// ];

const columnDefDefaultFn = (
  navigateCallback,
  isCancelModalOpen,
  maskId,
  maskUserId,
  t
) => [
  {
    accessorKey: "_id", // Assuming orderNumber is a key in the API
    header: t("OrdersTableText.orderId"),
    cell: ({ row }) => {
      const maskedId = maskId(row.original._id); // Mask the _id
      return <span>{maskedId}</span>;
    },
  },
  {
    accessorKey: "purchaseProducts", // For products purchased
    header: t("OrdersTableText.productName"),
    cell: ({ row }) => {
      const products = row.original.purchaseProducts || [];
      // console.log("Product Row", row.original);
      // Extract product names
  const productNames = products.map((product) => product.productId?.productName || "N/A");

  // Get the first two product names to display
  const displayedNames = productNames.slice(0, 2);
  const remainingCount = productNames.length - 2;
      return (
        <div className="product-list-cell">
          <Tooltip
            title={
              <div>
                {productNames.map((name, index) => (
                  <div key={index}>{name}</div>
                ))}
              </div>
            }
            arrow
          >
            <span className="product-list-summary">
              {displayedNames.join(", ")}
              {remainingCount > 0 && `, +${remainingCount} more`}
            </span>
          </Tooltip>
        </div>
        // <ul>
        //   {products.map((product, index) => (
        //     <li key={index}>
        //       <b>{product.productId.productName}</b>
        //       {/* - <strong>Qty: </strong>{product.purchaseQuantity}, <strong>Price: </strong>{product.amount} */}
        //     </li>
        //   ))}
        // </ul>
      );
    },
  },
  {
    accessorKey: "userId", // User ID field
    header: t("OrdersTableText.userId"),
    cell: ({ row }) => {
      const maskeduserId = maskUserId(row.original.userId); // Mask the _id
      return <span>{maskeduserId}</span>;
    },
  },
  {
    accessorKey: "orderType", // User ID field
    header: t("OrdersTableText.orderType"),
  },
  {
    accessorKey: "isDelivered", // User ID field
    header: t("OrdersTableText.isDelivered"),
  },
  {
    accessorKey: "orderStatus", // Order status
    header: t("OrdersTableText.orderStatus"),
    enableColumnFilter: false,
    cell: ({ row }) => {
      const status = row.original.orderStatus || "Unknown";
      let statusClass = "";
      switch (status) {
        case "inCart":
          statusClass = "bg-in-cart";
          break;
        case "started":
          statusClass = "bg-started";
          break;
        case "completed":
          statusClass = "bg-completed";
          break;
        case "working":
          statusClass = "bg-working";
          break;
        case "deliveryStarted":
          statusClass = "bg-delivery-started";
          break;
        case "failed":
          statusClass = "bg-failed";
          break;
        case "payed":
          statusClass = "bg-payed";
          break;
        default:
          statusClass = "bg-unknown";
      }

      return <span className={`badge ${statusClass}`}>{t(`${status}`)}</span>;
    },
  },
  columnHelper.accessor(
    (row) => {
      return row.orderStartDate ? getDate(row.orderStartDate) : "";
    },
    {
      id: "orderStartDate",
      header: t("OrdersTableText.orderStartDate"),
      // cell: lastNameCellFn
    }
  ),
  columnHelper.accessor(
    (row) => {
      return row.orderEndDate ? getDate(row.orderEndDate) : "";
    },
    {
      id: "orderEndDate",
      header: t("OrdersTableText.orderEndDate"),
      // cell: lastNameCellFn
    }
  ),
  // {
  //   accessorKey: "orderDescription", // Order description
  //   header: t("OrdersTableText.orderDescription"),
  // },

  {
    accessorKey: "isOrderPlaced", // Whether the order is placed
    header: t("OrdersTableText.orderChecklist"),
    cell: ({ row }) => (
      <div className="d-flex clays-sm">
        <button className="icon-clay">
          <span className="inner-clay color-green">
            <img src={pendingIcon} alt="pending" />
          </span>
        </button>
      </div>
    ),
  },
  {
    accessorKey: "deliveryAddressDetails", // Delivery details
    header: t("OrdersTableText.deliveryDetails"),
    cell: ({ row }) => {
      const address = row.original.deliveryAddressDetails;
      if (!address) {
        return <span>{t("OrdersTableText.noDeliveryDetails")}</span>;
      }

      // Format the tooltip content
      const tooltipContent = (
        <div
          style={{ maxWidth: "250px", fontSize: "0.9rem", lineHeight: "1.4" }}
        >
          <div>
            <strong>{t("OrdersTableText.deliveryTime")}:</strong>{" "}
            {address.deliveryTimeType || "N/A"}
          </div>
          <div>
            <strong>{t("OrdersTableText.pinCode")}:</strong>{" "}
            {address.pinCode || "N/A"}
          </div>
          <div>
            <strong>{t("OrdersTableText.city")}:</strong>{" "}
            {address.city || "N/A"}
          </div>
          <div>
            <strong>{t("OrdersTableText.deliveryTimeSlot")}:</strong>{" "}
            {address.timing?.deliveryTime || "N/A"}
          </div>
          <div>
            <strong>{t("OrdersTableText.startDate")}:</strong>
            {address.timing?.startDate
              ? new Date(address.timing.startDate).toLocaleDateString()
              : "N/A"}
          </div>
          <div>
            <strong>{t("OrdersTableText.ringBell")}:</strong>{" "}
            {address.isRingBellUsed ? t("Yes") : t("No")}
          </div>
          <div>
            <strong>{t("OrdersTableText.fullAddress")}:</strong>{" "}
            {address.fullAddress || "N/A"}
          </div>
        </div>
      );

      return (
        <Tooltip title={tooltipContent} arrow>
          <span className="tooltip-trigger">
            <span className="inner-clay color-black">
              <img src={eyeIcon} alt="View" />
            </span>
          </span>
        </Tooltip>
      );
    },
  },
  // {
  //   accessorKey: "deliveryAddressDetails", // Delivery details
  //   header: t("OrdersTableText.deliveryDetails"),
  //   cell: ({ row }) => {
  //     const address = row.original.deliveryAddressDetails;
  //     return address ? (
  //       <div className="coulmn">
  //         <span className="text-nowrap">{address.deliveryTimeType}</span>
  //         <span className="text-nowrap">{address.pincode}</span>
  //         <span className="text-nowrap">{address.city}</span>
  //         <span className="text-nowrap">{address.timing.deliveryTime}</span>
  //         <span className="text-nowrap">{address.timing.startDate}</span>
  //         <span className="text-nowrap">{address.isRingBellUsed}</span>
  //         <div>{address.fullAddress}</div>
  //         <div>
  //           {address.city}, {address.pinCode}
  //         </div>
  //       </div>
  //     ) : (
  //       "N/A"
  //     );
  //   },
  // },
  //   {
  //   accessorKey: "deliveryAddressDetails", // Delivery details
  //   header: t("OrdersTableText.deliveryDetails"),
  //   cell: ({ row }) => {
  //     const address = row.original.deliveryAddressDetails;
  //     return address ? (
  //       <div className="delivery-details">
  //         <div className="delivery-row">
  //           <span className="delivery-label">{t("OrdersTableText.deliveryTime")}:</span>
  //           <span className="delivery-value">{address.deliveryTimeType || "N/A"}</span>
  //         </div>
  //         <div className="delivery-row">
  //           <span className="delivery-label">{t("OrdersTableText.pinCode")}:</span>
  //           <span className="delivery-value">{address.pinCode || "N/A"}</span>
  //         </div>
  //         <div className="delivery-row">
  //           <span className="delivery-label">{t("OrdersTableText.city")}:</span>
  //           <span className="delivery-value">{address.city || "N/A"}</span>
  //         </div>
  //         <div className="delivery-row">
  //           <span className="delivery-label">{t("OrdersTableText.deliveryTimeSlot")}:</span>
  //           <span className="delivery-value">{address.timing?.deliveryTime || "N/A"}</span>
  //         </div>
  //         <div className="delivery-row">
  //           <span className="delivery-label">{t("OrdersTableText.startDate")}:</span>
  //           <span className="delivery-value">
  //             {address.timing?.startDate ? new Date(address.timing.startDate).toLocaleDateString() : "N/A"}
  //           </span>
  //         </div>
  //         <div className="delivery-row">
  //           <span className="delivery-label">{t("OrdersTableText.ringBell")}:</span>
  //           <span className="delivery-value">{address.isRingBellUsed ? t("Yes") : t("No")}</span>
  //         </div>
  //         <div className="delivery-full-address">
  //           <span className="delivery-label">{t("OrdersTableText.fullAddress")}:</span>
  //           <span className="delivery-value">{address.fullAddress || "N/A"}</span>
  //         </div>
  //       </div>
  //     ) : (
  //       <span>{t("OrdersTableText.noDeliveryDetails")}</span>
  //     );
  //   },
  // },

  {
    accessorKey: "action", // Action column
    header: t("OrdersTableText.Action"),
    cell: ({ row }) => {
      const orderRowData = row.original;
      return (
        <div className="d-flex clays-sm">
          <button
            className="icon-clay"
            onClick={() => navigateCallback(orderRowData._id)}
            title="View Order"
          >
            <span className="inner-clay color-black">
              <img src={eyeIcon} alt="View" />
            </span>
          </button>
          {orderRowData.isOrderPlaced === 1 &&
            !orderRowData.isCancelled &&
            orderRowData.orderStatus !== "completed" && (
              <DeclineModalComponent
                isOpen={isCancelModalOpen}
                onClose={() => {}}
                orderId={row.original._id}
                forModule="Order"
              />
            )}
        </div>
      );
    },
  },
];


const OutBoxColumnDefDefaultFn = (
  navigateCallback,
  editOrderFun,
  deleteOrderFun,
  placeOrderFun,
  handleDeclineModal,
  isCancelModalOpen,
  onClose,
  handleLinkOpenModal,
  viewReason,
  isReasonModalOpen,
  reasonData,
  onDeleteOrderBtnClick,
  t
) => [
  {
    accessorKey: "orderNumber",
    header: t("OrdersTableText.purchaseOrder"),
  },
  columnHelper.accessor(
    (row) => {
      // console.log("Test row", row);
      return row.buyerCompany ? row.buyerCompany.companyName : "N/A";
    },
    {
      id: "buyerCompany", // Custom ID for the column
      header: t("OrdersTableText.buyer"),
    }
  ),
  columnHelper.accessor(
    (row) => {
      return row.supplierCompany ? row.supplierCompany.companyName : "N/A";
    },
    {
      id: "supplierCompanyName", // Custom ID for the column
      header: t("OrdersTableText.Supplier"),
    }
  ),
  columnHelper.accessor(
    (row) => {
      return row.orderDate ? getDate(row.orderDate) : "";
    },
    {
      id: "orderStartDate",
      header: t("OrdersTableText.orderStartDate"),
      // cell: lastNameCellFn
    }
  ),
  columnHelper.accessor(
    (row) => {
      return row.orderDate ? getDate(row.orderDate) : "";
    },
    {
      id: "orderEndDate",
      header: t("OrdersTableText.orderEndDate"),
      // cell: lastNameCellFn
    }
  ),
  {
    accessorKey: "orderDescription",
    header: t("OrdersTableText.orderDescription"),
    // filterFn: firstNameFilterFn
  },
  {
    accessorKey: "orderStatus",
    header: t("OrdersTableText.orderStatus"),
    enableColumnFilter: false,
    cell: ({ row }) => {
      let statusClass = "";
      switch (row.original.orderStatus) {
        case "Placed":
          statusClass = "bg-placed";
          break;
        case "Cancelled":
          statusClass = "bg-cancelled";
          break;
        case "Open":
          statusClass = "bg-open";
          break;
        case "Fulfilled":
          statusClass = "bg-fulfilled";
          break;
        case "Partially Fulfilled":
          statusClass = "bg-fulfilled";
          break;
        case "Pending":
          statusClass = "bg-pending";
          break;
        // Add more cases as needed for other status values
        default:
          statusClass = "";
      }

      return (
        <span className={`badge ${statusClass}`}>
          {row.original.orderStatus}
        </span>
      );
    },
  },
  {
    accessorKey: "isOrderPlaced",
    header: t("OrdersTableText.orderChecklist"),
    cell: ({ row }) => (
      // <button onClick={() => navigateCallback(row.original.id)}>
      //     Go to Details
      // </button>
      <div className="d-flex clays-sm justify-content-center">
        <button className="cir gray-bg">
          <span className="inner-clay color-green"></span>
        </button>
      </div>
    ),
  },
  {
    accessorKey: "action",
    header: t("OrdersTableText.Action"),
    cell: ({ row }) => {
      const orderRowData = row.original;
      // console.log('______', row)
      return (
        <div className="d-flex clays-sm">
          <button
            className="icon-clay"
            onClick={() => navigateCallback(row.original.orderId, "view")}
            title="View Order"
          >
            <span className="inner-clay color-black">
              <img src={eyeIcon} alt="Edit" />
            </span>
          </button>
          {orderRowData.isOrderPlaced !== 1 && ( // orderRowData.isCancelled !== 1 &&
            <>
              <button
                className="icon-clay"
                onClick={() =>
                  editOrderFun(row.original.orderId, "edit", "Open")
                }
                title="Edit Order"
              >
                <img src={editIcon} alt="Edit" />
              </button>
              {/* <button
                  className="icon-clay delete"
                  onClick={() => deleteOrderFun(row.original.orderId, "delete")}
                  title="Delete Order"

                >
                  <img src={deleteIcon} alt="Delete" />
              
                  
                </button> */}
              <button
                className="icon-clay delete"
                onClick={() =>
                  onDeleteOrderBtnClick(row.original.orderId, "delete")
                }
                title="Delete Order"
              >
                <img src={deleteIcon} alt="Delete" />
              </button>
            </>
          )}
          {orderRowData.isOrderPlaced === 1 &&
            orderRowData.isCancelled !== 1 && (
              <button
                className="icon-clay"
                onClick={() =>
                  editOrderFun(row.original.orderId, "edit", "Place")
                }
                title="Edit Order"
              >
                <img src={editIcon} alt="Edit" />
              </button>
            )}

          {orderRowData.isLinked !== 1 &&
            orderRowData.isCancelled !== 1 &&
            orderRowData.isOrderPlaced !== 1 && ( //1 && state.role !== "Brand"
              // <></>
              <button
                className="icon-clay"
                onClick={() =>
                  handleLinkOpenModal("link", row.original.orderId)
                }
                title="Link Order"
              >
                <img src={linkIcon} alt="Link" />
              </button>
            )}

          {orderRowData.isOrderPlaced !== 1 && (
            <button
              className="icon-clay"
              onClick={() => placeOrderFun(orderRowData, "place")}
              title="Place Order"
            >
              <img src={placeOrderIcon} alt="Place Order" />
            </button>
          )}

          {orderRowData.isOrderPlaced === 1 &&
            orderRowData.isCancelled !== 1 &&
            orderRowData.orderStatus !== "Fulfilled" && (
              <DeclineModalComponent
                isOpen={isCancelModalOpen}
                onClose={() => onClose}
                orderId={row.original.orderId}
                forModule="Order"
              />
            )}

          {orderRowData.isCancelled === 1 && (
            <>
              <ReasonModalComponent
                open={isReasonModalOpen}
                onClose={() => onClose}
                // action={actionType}
                reasonData={row.original}
              />
            </>
          )}

          {orderRowData.orderStatus === "Partially Fulfilled" &&
            orderRowData.isFulfillEnabled === 1 && (
              <button
                className="icon-clay"
                onClick={() => orderFulfill(orderRowData)}
              >
                <img src={fulfillIcon} alt="Fulfill" />
              </button>
            )}
        </div>
      );
    },
  },
];
// {
//   accessorKey: 'action',
//   header: 'Actions',
//   cell: ({ row }) => (
//     // <button onClick={() => navigateCallback(row.original.orderId)}>
//     //     Go to Details
//     // </button>
//     <div className="d-flex clays-sm">
//       {row.original.orderStatus !== 'Fulfilled'? <button className="icon-clay" onClick={() => navigateCallback(row.original.orderId, 'edit')}>
//         {/* <span className="inner-clay color-black"><i className="bi bi-eye"><img src={editIcon} alt="View"/></i></span> */}
//         <span className="inner-clay color-black"><img src={editIcon} alt="Edit"/></span>

//       </button>: null}
//      <button className="icon-clay" onClick={() => navigateCallback(row.original.orderId, 'view')}>
//         {/* <span className="inner-clay color-black"><i className="bi bi-eye"><img src={eyeIcon} alt="View"/></i></span> */}
//         <span className="inner-clay color-black"><img src={eyeIcon} alt="View" /></span>

//       </button>:
//       {row.original.orderStatus== 'Open'?
//       <button className="icon-clay">
//         {/* <span className="inner-clay color-red"><i className="bi bi-x-lg"><img src={xIcon} alt="Delete"/></i></span> */}
//         <span className="inner-clay color-red"><img src={xIcon} alt="Delete" /></span>

//       </button>:null}
//     </div>
//   )
// },
const ProductColumnDefDefaultFn = (navigateCallback, editProductByIdFun, deleteProductByIdFun, t) => [
  {
    accessorKey: "serialNo",
    header: "Serial No",
    cell: ({ row }) => {
      const rowIdx = row.index;
      // return enablePagination ? (pageIndex * pageSize) + rowIdx + 1 : rowIdx + 1;
      return rowIdx + 1;
    },
  },
  {
    accessorKey: "productName",
    header: "Product",
  },
  {
    accessorKey: "productDescription",
    header: "Product Description",
  },
  {
    accessorKey: "productQty",
    header: "Quantity",
  },
  {
    accessorKey: "productUom",
    header: "Unit",
  },
  {
    accessorKey: "blendPercentage",
    header: "Blend % of Birla Cellulose",
  },
  {
    accessorKey: "glm",
    header: "Grams/Linear Meter",
  },
  {
    accessorKey: "mpg",
    header: "Meters/Garments",
  },
  {
    accessorKey: "action",
    header: "Actions",
    cell: ({ row }) => {
      // console.log('__product_', row)

      return (
        <div className="d-flex clays-sm">
          <button
            className="icon-clay"
            onClick={() =>
              editProductByIdFun(
                row.original.orderProductId,
                row.original.productId,
                "edit"
              )
            }
          >
            <span className="inner-clay color-black">
              <img src={editIcon} alt="Edit" />
            </span>
          </button>

          <button
            className="icon-clay"
            onClick={() =>
              deleteProductByIdFun(
                row.original.orderProductId,
                row.original.productId,
                "delete"
              )
            }
          >
            <span className="inner-clay color-red">
              <img src={deleteIcon} alt="Delete" />
            </span>
          </button>
        </div>
      );
    },
  },
];
const ProductColumnDefForeReviewOrder = (navigateCallback, editProductByIdFun, deleteProductByIdFun, t) => [
  {
    accessorKey: "serialNo",
    header: "Serial No",
    cell: ({ row }) => {
      const rowIdx = row.index;
      // return enablePagination ? (pageIndex * pageSize) + rowIdx + 1 : rowIdx + 1;
      return rowIdx + 1;
    },
  },
  {
    accessorKey: "productName",
    header: "Product",
  },
  {
    accessorKey: "productDescription",
    header: "Product Description",
  },
  {
    accessorKey: "productQty",
    header: "Quantity",
  },
  {
    accessorKey: "productUom",
    header: "Unit",
  },
  {
    accessorKey: "blendPercentage",
    header: "Blend % of Birla Cellulose",
  },
  {
    accessorKey: "glm",
    header: "Grams/Linear Meter",
  },
  {
    accessorKey: "mpg",
    header: "Meters/Garments",
  }
];

const ProductColumnforViewOutboxOrder = (t) => [
  {
    accessorKey: "serialNo",
    header: "Serial No",
    cell: ({ row }) => {
      const rowIdx = row.index;
      // return enablePagination ? (pageIndex * pageSize) + rowIdx + 1 : rowIdx + 1;
      return rowIdx + 1;
    },
  },
  {
    accessorKey: "productName",
    header: "Product",
  },
  {
    accessorKey: "productDescription",
    header: "Product Description",
  },
  {
    accessorKey: "productQty",
    header: "Quantity",
  },
  {
    accessorKey: "productUom",
    header: "Unit",
  },
  {
    accessorKey: "blendPercentage",
    header: "Blend % of Birla Cellulose",
  },
  {
    accessorKey: "glm",
    header: "Grams/Linear Meter",
  },
  {
    accessorKey: "mpg",
    header: "Meters/Garments",
  },
];
// Define column structure for MainTable
const LinkedOrderColumnDef = (
  handleLinkOrder,
  handleUnLinkOrder,
  linkedOrderNum,
  t
) => [
  columnHelper.accessor(row => {
    return row.order_date ? getDate(row.order_date) : "";
  },
    {
      //   id: 'order_date', // Unique ID for the order date column
      header: "Order Date",
      id: "order_date",
    }),
    {
      //   id: 'sender_company_name', // Unique ID for the buyer column
      header: "Buyer",
      accessorKey: "sender_company_name",
    },
    {
      id: "order_number", // Unique ID for the purchase order column
      header: "Purchase Order",
      accessorKey: "order_number", // accessorKey is the "key" in the data
    },
    {
      //   id: 'action', // Unique ID for the action column
      header: "Action",
      accessorKey: "action",
      cell: ({ row }) => {
        // console.log(
        //   "_Linked____",
        //   row.original.order_number,
        //   "\nLinkedOrderNum ::",
        //   linkedOrderNum
        // );
        return (
          <>
            {linkedOrderNum === row.original.order_number ? (
              <button
                style={{ border: "unset", background: "unset" }}
                onClick={() => handleUnLinkOrder(row.original.order_id, "unlink")}
              >
                Unlink
              </button>
            ) : (
              <button
                style={{ border: "unset", background: "unset" }}
                onClick={() => handleLinkOrder(row.original, "link")}
              >
                Link
              </button>
            )}
          </>
        );
      },
    },
    // ... Add other columns as needed
  ];

// Define column structure for the Stocks Table
const StockColumnDefDefaultFn = (enablePagination) => [
  {
    accessorKey: "invoiceNumber",
    header: "Supplier Invoice Number",
  },
  {
    accessorKey: "product.productName",
    header: "Product",
  },
  {
    accessorKey: "buyerCompany.companyName",
    header: "Buyer",
  },
  {
    accessorKey: "sellerCompany.companyName",
    header: "Supplier",
  },
  {
    accessorKey: "productTypeName",
    header: "Type",
  },

  {
    accessorKey: "productQty",
    header: "Quantity",
  },
  {
    accessorKey: "productUOM",
    header: "Unit",
  },
  {
    accessorKey: "lotNumber",
    header: "Lot#",
  },

  {
    accessorKey: "blendPercentage",
    header: "Blend % of Birla Cellulose",
  },
];
// Define column structure for MainTable of Process Loss
const ProcessLossColumnDef = () => [
  {
    header: "Entity",
    accessorKey: "seller_company_name",
  },
  {
    header: "Material Produced",
    accessorKey: "product_name",
  },
  {
    header: "Quantity",
    accessorKey: "product_qty",
  },
  {
    header: "Unit",
    accessorKey: "product_uom",
  },
  {
    header: "Material Consumed",
    accessorKey: "consume_product_name",
  },
  {
    header: "Quantity",
    accessorKey: "consume_product_qty",
  },
  {
    header: "Unit",
    accessorKey: "consume_product_uom",
  },
  {
    header: "Loss %",
    accessorKey: "process_loss",
  },
];

const TrfColumnDefDefaultFn = (navigateCallback, isCancelModalOpen, t) => [
  {
    accessorKey: 'referenceNumber',
    header: 'Reference Number'
  },
  {
    accessorKey: 'itemNumber',
    header: 'Item Number'
  },
  {
    accessorKey: 'courierNumber',
    header: 'Courier Number'
  },
  {
    accessorKey: 'requestedBy',
    header: 'Requested By'
  },
  {
    accessorKey: 'status',
    header: 'Status'
  },
  {
    accessorKey: 'remark',
    header: 'Remark'
  },
  {
    accessorKey: 'action',
    header: 'Action'
  },

];
const TrfUserColumnDefDefaultFn = (
  viewTrf,
  shortlistUnShortlistTrf,
  verifyTrf,
  notVerifyTrf,
  rejectTrfReason,
  rejectTrf,
  t
) => [
    {
      accessorKey: "courierId",
      header: "Reference Number",
    },
    {
      accessorKey: "invoiceNumber",
      header: "Item Number",
    },
    {
      accessorKey: "companyName",
      header: "Requested By",
    },
    {
      accessorKey: "birlaFibre",
      header: "Birla Fibre",
    },
    {
      accessorKey: "referenceCourierId",
      header: "Courier Number",
    },
    // {
    //   accessorKey: 'status',
    //   header: 'Status'
    // },
    {
      accessorKey: "status",
      header: t("Status"),
      cell: ({ row }) => {
        let statusClass = "";
        const trfRowData = row.original;
        // console.log("TRF ROW DATA !!!!", trfRowData)
        switch (trfRowData.status) {
          case "Shortlisted":
            statusClass = "bg-placed";
            break;
          case "Not Shortlisted":
            statusClass = "bg-verified";
            break;
          case "Submitted":
            statusClass = "bg-open";
            break;
          case "Verified":
            statusClass = "bg-fulfilled";
            break;
          case "Not Verified":
            statusClass = "bg-cancelled";
            break;
          case "Rejected":
            statusClass = "bg-cancelled";
            break;
          // Add more cases as needed for other status values
          default:
            statusClass = "";
        }

        return (
          <span className={`badge ${statusClass}`}>{trfRowData.status}</span>
        );
      },
    },
    {
      accessorKey: "action",
      header: "Action",
      cell: ({ row }) => {
        const trfRowData = row.original;
        const checkedIt = trfRowData.isShortlisted;
        return (
          <div className="d-flex clays-sm">
            {/* {console.log("HERE IN THE COLUMN DEF",trfRowData)} */}
            <button
              className="icon-clay"
              onClick={() => viewTrf(trfRowData.trfId, "view", trfRowData)}
            >
              <span className="inner-clay color-black">
                <img src={eyeIcon} alt="View" />
              </span>
            </button>
            {/* {console.log("ssss userDetails ",userDetails)} */}
            {trfRowData.status === "Shortlisted" || trfRowData.status === "Not Shortlisted" ?
              <input style={{ marginLeft: '3px' }} type="checkbox" checked={checkedIt} title="shortlist" onClick={() => shortlistUnShortlistTrf(trfRowData.trfId, trfRowData.isShortlisted ? 'unShortlist' : 'shortlist')} /> :
              null}
            {trfRowData.status === "Shortlisted" || trfRowData.status === "Not Shortlisted" ? (
              <button
                className="icon-clay"
                onClick={() =>
                  verifyTrf(trfRowData.trfId, "Verify", trfRowData)
                }
              >
                <span className="inner-clay color-black">
                  <img src={TrfVerify} alt="Verify" />
                </span>
              </button>
            ) : null}
            {trfRowData.status === "Shortlisted" || trfRowData.status === "Not Shortlisted" ? (
              <button
                className="icon-clay"
                onClick={() =>
                  notVerifyTrf(trfRowData.trfId, "NotVerify", trfRowData)
                }
              >
                <span className="inner-clay color-black">
                  <img src={NotVerifyIcon} alt="NotVerify" />
                </span>
              </button>
            ) : null}
            {trfRowData.status === "Not Verified" || trfRowData.status === "Rejected" ? (
              <button
                className="icon-clay"
                onClick={() =>
                  rejectTrfReason(trfRowData.trfId, "Reject", trfRowData)
                }
              >
                <span className="inner-clay color-black">
                  <img src={reasonIcon} alt="Reject" />
                </span>
              </button>
            ) : null}
            {trfRowData.status === "Shortlisted" || trfRowData.status === "Not Shortlisted" ? (
              <button
                className="icon-clay"
                onClick={() => rejectTrf(trfRowData.trfId, "Reject", trfRowData)}
              >
                <span className="inner-clay color-black">
                  <img src={xIcon} alt="Reject" />
                </span>
              </button>
            ) : null}
          </div>
        );
      },
    },
  ];
const TrfAllUserColumnDefDefaultFn = (viewTrfFun, t, updateCourierFun, isReasonModalOpen) => [
  {
    accessorKey: 'courierId',
    header: 'Reference Number'
  },
  {
    accessorKey: 'invoiceNumber',
    header: 'Item Number'
  },
  {
    accessorKey: 'companyName',
    header: 'Requested By'
  },
  {
    accessorKey: 'birlaFibre',
    header: 'Birla Fibre'
  },
  {
    accessorKey: 'referenceCourierId',
    header: 'Courier Number'
  },
  {
    accessorKey: 'status',
    header: 'Status'
  },
  {
    accessorKey: "status",
    header: t("Status"),
    cell: ({ row }) => {
      let statusClass = "";
      const trfRowData = row.original
      // console.log("TRF ROW DATA !!!!", trfRowData)
      switch (trfRowData.status) {
        case "Shortlisted":
          statusClass = "bg-placed";
          break;
        case "Not Shortlisted":
          statusClass = "bg-cancelled";
          break;
        case "Submitted":
          statusClass = "bg-open";
          break;
        case "Verified":
          statusClass = "bg-fulfilled";
          break;
        case "Not Verified":
          statusClass = "bg-fulfilled";
          break;
        case "Rejected":
          statusClass = "bg-pending";
          break;
        // Add more cases as needed for other status values
        default:
          statusClass = "";
      }
      return (
        <span className={`badge ${statusClass}`}>
          {trfRowData.status}
        </span>
      );
    },
  },
  {
    accessorKey: 'action',
    header: 'Action',
    cell: ({ row }) => {
      const trfRowData = row.original
      const checkedIt = trfRowData.isShortlisted;
      return (<div className="d-flex clays-sm">
        {/* {console.log("HERE IN THE COLUMN DEF", trfRowData)} */}
        {trfRowData.isRejectReason === 0 && trfRowData.isVerified === 0 && (
          <>
            <button className="icon-clay" onClick={() => updateCourierFun(trfRowData.trfId, 'view')}>
              <span className="inner-clay color-black"><img src={editIcon} alt="Edit" /></span>
            </button>

          </>)}
        <button className="icon-clay" onClick={() => viewTrfFun(trfRowData.trfId, 'view')}>
          <span className="inner-clay color-black"><img src={eyeIcon} alt="View" /></span>
        </button>
        {trfRowData.isRejectReason === 0 && trfRowData.isSubmitted === 1 && (
          <>
            <button className="icon-clay" onClick={() => updateCourierFun(trfRowData.trfId, 'view')}>
              <span className="inner-clay color-black"><FileOutlineIcon /></span>
            </button>
          </>)}
        {/* {(!trfRowData.isVerified)  && !trfRowData.isRejectReason &&
            <input style={{ marginLeft: '3px' }} type="checkbox" checked={checkedIt} title="shortlist" onClick={() => shortlistUnShortlistTrf(trfRowData.trfId,trfRowData.isShortlisted?'unShortlist':'shortlist')} />
            } */}

        {trfRowData.isRejectReason === 1 && trfRowData.isVerified === 0 && (
          <>
            <ReasonModalComponent
              open={isReasonModalOpen}
              onClose={() => onClose}
              // action={actionType}
              reasonData={trfRowData}
            />
          </>
        )}
      </div>
      )
    }
  },

];
// const columnDeliveryboy = (navigateCallback, isCancelModalOpen, t) => [
//   {
//     accessorKey: "orderNumber",
//     header: t("OrdersTableText.purchaseOrder"),
//   },
//   columnHelper.accessor(
//     (row) => {
//       // console.log("Test row", row);
//       return row.buyerCompany ? row.buyerCompany.companyName : "N/A";
//     },
//     {
//       id: "buyerCompany", // Custom ID for the column
//       header: t("OrdersTableText.buyer"),
//     }
//   ),
//   columnHelper.accessor(
//     (row) => {
//       return row.supplierCompany ? row.supplierCompany.companyName : "N/A";
//     },
//     {
//       id: "supplierCompanyName", // Custom ID for the column
//       header: t("OrdersTableText.Supplier"),
//     }
//   ),
//   columnHelper.accessor(
//     (row) => {
//       return row.orderDate ? getDate(row.orderDate) : "";
//     },
//     {
//       id: "orderDate",
//       header: t("OrdersTableText.orderDate"),
//       // cell: lastNameCellFn
//     }
//   ),
//   {
//     accessorKey: "orderDescription",
//     header: t("OrdersTableText.orderDescription"),
//     // filterFn: firstNameFilterFn
//   },
//   {
//     accessorKey: "orderStatus",
//     header: t("OrdersTableText.orderStatus"),
//     enableColumnFilter: false,
//     cell: ({ row }) => {
//       let statusClass = "";
//       switch (row.original.orderStatus) {
//         case "Placed":
//           statusClass = "bg-placed";
//           break;
//         case "Cancelled":
//           statusClass = "bg-cancelled";
//           break;
//         case "Open":
//           statusClass = "bg-open";
//           break;
//         case "Fulfilled":
//           statusClass = "bg-fulfilled";
//           break;
//         case "Partially Fulfilled":
//           statusClass = "bg-fulfilled";
//           break;
//         case "Pending":
//           statusClass = "bg-pending";
//           break;
//         // Add more cases as needed for other status values
//         default:
//           statusClass = "";
//       }

//       return (
//         <span className={`badge ${statusClass}`}>
//           {row.original.orderStatus}
//         </span>
//       );
//     },
//   },
//   {
//     accessorKey: "isOrderPlaced",
//     header: t("OrdersTableText.orderChecklist"),
//     cell: ({ row }) => (
//       // <button onClick={() => navigateCallback(row.original.id)}>
//       //     Go to Details
//       // </button>
//       <div className="d-flex clays-sm">
//         <button className="icon-clay">
//           {/* <span className="inner-clay color-green"><i className="bi bi-pencil-square"><img src={pendingIcon} alt="pending"/></i></span> */}
//           <span className="inner-clay color-green">
//             <img src={pendingIcon} alt="pending" />
//           </span>
//         </button>
//       </div>
//     ),
//   },
//   {
//     accessorKey: "action",
//     header: t("OrdersTableText.Action"),
//     cell: ({ row }) => {
//       // <button onClick={() => navigateCallback(row.original.orderId)}>
//       //     Go to Details
//       // </button>
//       const orderRowData = row.original;
//       return (
//         <div className="d-flex clays-sm">
//           <button
//             className="icon-clay"
//             onClick={() => navigateCallback(orderRowData.orderId)}
//             title="View Order"
//           >
//             {/* <span className="inner-clay color-black"><i className="bi bi-eye"><img src={eyeIcon} alt="View"/></i></span> */}
//             <span className="inner-clay color-black">
//               <img src={eyeIcon} alt="View" />
//             </span>
//           </button>
//           {orderRowData.isOrderPlaced === 1 &&
//             orderRowData.isCancelled !== 1 &&
//             orderRowData.orderStatus !== "Fulfilled" && (
//               <DeclineModalComponent
//                 isOpen={isCancelModalOpen}
//                 onClose={() => onClose}
//                 orderId={row.original.orderId}
//                 forModule="Order"
//               />
//             )}
//           {/* <button className="icon-clay">
//           <span className="inner-clay color-red"><img src={xIcon} alt="Delete" /></span>
//         </button>*/}
//         </div>
//       );
//     },
//   },
// ];
const columnDeliveryboy = (edit, view, _delete) => [
  {
    header: "No.",
    Footer: "Id",
    accessorKey: "_id",
    disableFilters: true,
    sticky: "left",
    cell: ({ row }) => {
      //console.log({ row });
      return <div style={{ justifyContent: "right" }}>{row.index + 1}</div>;
    },
  },

  {
    header: "Name",
    accessorKey: "name",
  },
  {
    header: "City",
    accessorKey: "city",
  },
  {
    header: "Zipcode",
    accessorKey: "zipcode",
    // cell: ({ row }) => {
    //   console.log("test  1", row);
    //   console.log("test  ", row.original.zipcodes[0].zipcode);
    //   return (
    //     <div style={{ justifyContent: "right" }}>
    //       {row.original.zipcodes[0].zipcode}
    //     </div>
    //   );
    // },
  },
  {
    header: "Duty Status",
    accessorKey: "dutyStatus",
    cell: ({ row }) => (row.original.dutyStatus ? "On Duty" : "Off Duty"),
  },
  {
    header: "Contact",
    accessorKey: "mobileNumber",
  },
  {
    header: "Date Of Join",
    accessorKey: "createdDate",
    // className: "text-center",
    cell: ({ row }) => {
      // console.log({ row });
      // console.log(row.original.createdAt);

      return (
        // console.log(row.original.deliverySlot.from )

        getDate(row.original.createdAt)
      );
    },
  },
  {
    header: "Status",
    accessorKey: "isActive",
    cell: (row) => {
      // console.log("Condition", row.row.original.isActive);
      let statusClass = "";
      switch (row.row.original.isActive) {
        case true:
          statusClass = "bg-placed";
          break;
        // case "Cancelled":
        //   statusClass = "bg-cancelled";
        //   break;
        // case "Open":
        //   statusClass = "bg-open";
        //   break;
        // case "Fulfilled":
        //   statusClass = "bg-fulfilled";
        //   break;
        // case "Partially Fulfilled":
        //   statusClass = "bg-fulfilled";
        //   break;
        // case "Pending":
        //   statusClass = "bg-pending";
        //   break;
        // Add more cases as needed for other status values
        default:
          statusClass = "bg-pending";
      }
      return (
        <span className={`badge ${statusClass}`}>
          {row.row.original.isActive ? "Activated" : "Deactivated"}
        </span>
      );
    },
    // cell: ({ row }) => (row.original.isActive ? "Activated" : "Deactivated"),
  },
  {
    header: "Covid",
    accessorKey: "covid",
    cell: (row) => (
      <button
        className="icon-clay"
        onClick={() => covidmodel(row)}
        title="Covid report"
      >
        Medical
        {/* <Icon icon="fa-solid:file-medical" color="#7c0e0e" height="25" /> */}
      </button>
    ),
  },
  {
    header: "Manager",
    accessorKey: "managerName",
  },
  {
    header: "Job Role",
    accessorKey: "isFreelancer",
    cell: ({ row }) => (row.original  .isFreelancer ? "Freelancer" : "Normal"),
  },
  {
    header: "Vehicle",
    accessorKey: "vehicle",
  },
  // {
  //   header: "Approved",
  //   accessorKey: "staus",
  // },

  {
    header: "Actions",
    accessorKey: "actions",
    // maxWidth: 200,
    // minWidth: 180,
    sortable: false,
    cell: (row) => (
      <>
        <button className="icon-clay" onClick={() => edit(row)} title="Edit">
          {/* <i className="material-icons">&#xE254;</i> */}
          Edit
          {/* <Icon icon="bx:bx-edit" color="#7c0e0e" height="25" /> */}
        </button>
        <button
          className="icon-clay"
          onClick={() => {
            confirmAlert({
              title: message.ALERT,
              message: message.DELETE_CONFIRMATION,
              buttons: [
                {
                  label: "Confirm",
                  onClick: () => {
                    _delete(row);
                  },
                },
                {
                  label: "Cancel",
                  onClick: () => {
                    return false;
                  },
                },
              ],
            });
          }}
          title="Delete"
        >
          Delete
          {/* <i className="material-icons">&#xE872;</i> */}
          {/* <Icon icon="ic:baseline-delete" color="#7c0e0e" height="25" /> */}
        </button>
      </>
    ),
  },
];
//assigned Order
const ASSIGNEDORDERCOLUMNS = ({ view, reassign, _delete, edit }) => [
  {
    header: "No#",
    Footer: "Id",
    accessorKey: "_id",
    disableFilters: true,
    sticky: "left",
    cell: ({ row }) => {
      //  //console.log({ row });
      return <div style={{ justifyContent: "right" }}>{row.index + 1}</div>;
    },
    // isSorted: true,
  },

  {
    header: "Order ID",
    accessorKey: "orderId",
  },
  {
    header: "Order Date",
    accessorKey: "createdAt",
    cell: ({ row }) => {
      // console.log({ row });
      // console.log(row.original.createdAt);

      return (
        // console.log(row.original.deliverySlot.from )

        getDate(row.original.createdAt)
      );
    },
  },
  {
    header: "Order Delivery Date",
    accessorKey: "deliveryDate",
    cell: ({ row }) => {
      // console.log({ row });
      // console.log(row.original.deliveryDate);

      return (
        // console.log(row.original.deliverySlot.from )

        getDate(row.original.deliveryDate)
      );
    },
  },

  {
    header: "Delivery Slot Time",
    accessorKey: "deliverySlot",
    cell: ({ row }) => {
      // console.log({ row });
      // console.log(row.original.deliverySlot.from);

      return (
        // console.log(row.original.deliverySlot.from )

        <div style={{ justifyContent: "right" }}>
          {/* {row.original.deliverySlot.from} - {row.original.deliverySlot.to} */}
          {row.original.orderStartDate} - {row.original.orderEndDate}
        </div>
      );
    },
  },
  // {
  // header: "Manager",
  // accessorKey: "deliverymanager",
  // },
  {
    header: "Total Amount",
    accessorKey: "grandTotal",
  },
  {
    header: "Payment",
    accessorKey: "paymentStatus",
  },
  {
    header: "Delivery Type",
    accessorKey: "type",
    className: "text-center",
  },
  {
    header: "Order Status",
    accessorKey: "status",
  },
  // {
  //   header: "Delivery Boy",
  //   accessorKey: "deliveryboy",
  //   className: "text-center",
  // },
  {
    header: "Re-Assign",
    accessorKey: "re-Assign",
    cell: (row) => (
       <button
                  className="icon-clay" onClick={() => edit(row)} title="Edit">
        {/* <Icon icon="fluent:add-circle-16-regular" color="#7c0e0e" height="30" /> */}
      </button>
    ),
  },
  // {
  //   header: "Re-Assign",
  //   accessorKey: "re-assign",
  //   cell: (row) => (
  //     <button theme="white" onClick={() => reassign(row)} title="Assign">
  //       {/* <i className="material-icons">&#xE5CA;</i> */}
  //       <Icon icon="fluent:add-circle-16-regular" color="#7c0e0e" height="30" />
  //     </button>
  //   ),
  // },
  
];
//Unassigned Order
export const UNASSIGNEDORDERCOLUMNS = ({ view, edit, _delete }) => [
  {
    header: "No#",
    Footer: "Id",
    accessorKey: "_id",
    disableFilters: true,
    sticky: "left",
    cell: ({ row }) => {
      return <div style={{ justifyContent: "right" }}>{row.index + 1}</div>;
    },
    // isSorted: true,
  },

  {
    header: "Order ID",
    accessorKey: "orderId",
  },
  // {
  //   header: "Manager",
  //   accessorKey: "deliverymanager",
  // },
  {
    header: "Order Date",
    accessorKey: "createdAt",
    cell: ({ row }) => {
      // console.log({ row });
      // console.log(row.original.createdAt);

      return (
        // console.log(row.original.deliverySlot.from )

        getDate(row.original.createdAt)
      );
    },
  },

  {
    header: "Order Delivery Date",
    accessorKey: "deliveryDate",
    cell: ({ row }) => {
      // console.log({ row });
      // console.log(row.original.deliveryDate);

      return (
        // console.log(row.original.deliverySlot.from )

        getDate(row.original.deliveryAddressDetails.timing.startDate)
      );
    },
  },

  // {
  //   header: "Delivery Slot Time",
  //   accessorKey: "deliverySlot",
  //   cell: ({ row }) => {
  //     console.log({ row });
  //     // console.log(row.original.deliverySlot.from);

  //     return (
  //       // console.log(row.original.deliverySlot.from )

  //       <div style={{ justifyContent: "right" }}>
  //         {row.original.orderStartDate} - {row.original.orderEndDate}
  //       </div>
  //     );
  //   },
  // },
  columnHelper.accessor(
    (row) => {
      return row.deliveryAddressDetails
        ? row.deliveryAddressDetails.deliveryTimeType
        : "N/A";
    },
    {
      id: "deliveryTimeType", // Custom ID for the column
      header: "Delivery Slot Time", // t("OrdersTableText.Supplier"),
    }
  ),
  // {
  //   header: "Total Amount",
  //   accessorKey: "grandTotal",
  // },
  columnHelper.accessor(
    (row) => {
      return row.purchaseProducts ? row.purchaseProducts.amount : "N/A";
    },
    {
      id: "amount", // Custom ID for the column
      header: "Total Amount", // t("OrdersTableText.Supplier"),
    }
  ),
  {
    header: "Payment",
    accessorKey: "paymentMethod",
  },
  // {
  //   header: "Zipcode",
  //   accessorKey: "zipcode",
  // },
  columnHelper.accessor(
    (row) => {
      return row.deliveryAddressDetails
        ? row.deliveryAddressDetails.pinCode
        : "N/A";
    },
    {
      id: "pinCode", // Custom ID for the column
      header: "Delivery Slot Time", // t("OrdersTableText.Supplier"),
    }
  ),
  {
    header: "Delivery Type",
    accessorKey: "orderType",
    className: "text-center",
  },
  {
    header: "Assign",
    accessorKey: "assign",
    cell: (row) => (
      <button theme="white" onClick={() => edit(row)} title="Edit">
        {/* <Icon icon="fluent:add-circle-16-regular" color="#7c0e0e" height="30" /> */}
      </button>
    ),
  },
];
const MANAGERCOLUMNS = ({ view, edit, _delete, updateStatus }) => [
  {
    header: "No#",
    Footer: "Id",
    accessorKey: "_id",
    disableFilters: true,
    sticky: "left",
    cell: ({ row }) => {
      //  //console.log({ row });
      return <div style={{ justifyContent: "right" }}>{row.index + 1}</div>;
    },
    // isSorted: true,
  },

  {
    header: "Name",
    accessorKey: "firstName",
  },
  {
    header: "User Name/Contact No",
    accessorKey: "email",
  },
  {
    header: "Country",
    accessorKey: "country",
  },
  {
    header: "State",
    accessorKey: "state",
  },
  {
    header: "City",
    accessorKey: "city",
    className: "text-center",
  },
  {
    header: "Zipcode",
    accessorKey: "zipcode",
    cell: (row) => {
      // console.log("test  1", row);
      // console.log(row.data[row.row.index]);
      const { managers } = row.row.original;
      // console.log("test  ", managers.zipCodes);
      return (
        <>
          {managers.zipCodes &&
            managers.zipCodes.map((zip, index) => {
              return (
                <div key={index} style={{ justifyContent: "right" }}>
                  {zip}
                </div>
              );
            })}
        </>
      );
    },
  },
  // {
  //   header: "Contact No",
  //   accessorKey: "contactNo",
  // },
  {
    header: "Status",
    accessorKey: "isActive",
    cell: (row) => {
      // console.log("Condition", row.row.original.isActive);
      let statusClass = "";
      switch (row.row.original.isActive) {
        case true:
          statusClass = "bg-placed";
          break;
        // case "Cancelled":
        //   statusClass = "bg-cancelled";
        //   break;
        // case "Open":
        //   statusClass = "bg-open";
        //   break;
        // case "Fulfilled":
        //   statusClass = "bg-fulfilled";
        //   break;
        // case "Partially Fulfilled":
        //   statusClass = "bg-fulfilled";
        //   break;
        // case "Pending":
        //   statusClass = "bg-pending";
        //   break;
        // Add more cases as needed for other status values
        default:
          statusClass = "bg-pending";
      }
      return (
        <span className={`badge ${statusClass}`}>
          {row.row.original.isActive ? "Activated" : "Deactivated"}
        </span>
      );
    },
  },
  // {
  //   header: "Set Status",
  //   cell: ({ row }) => {
  //     return (
  //       <ButtonGroup size="sm" className=" ">
  //         <button
  //           theme="white"
  //           onClick={() => updateStatus(row)}
  //           title="Active and Deactive"
  //         >
  //           {!row.values.isActive ? "Active" : "Deactive"}
  //         </button>
  //       </ButtonGroup>
  //     );
  //   },
  // },
  {
    header: "Actions",
    accessorKey: "actions",
    maxWidth: 150,
    minWidth: 140,
    className: "text-right",
    sortable: false,
    cell: (row) => (
      <>
        <button theme="white" onClick={() => edit(row)} title="Edit">
          <i className="material-icons">&#xE254;</i>
          {/* <Icon icon="bx:bx-edit" color="#7c0e0e" height="25" /> */}
        </button>
        <button
          theme="white"
          onClick={() => {
            confirmAlert({
              title: message.ALERT,
              message: message.DELETE_CONFIRMATION,
              buttons: [
                {
                  label: "Confirm",
                  onClick: () => {
                    _delete(row);
                  },
                },
                {
                  label: "Cancel",
                  onClick: () => {
                    return false;
                  },
                },
              ],
            });
          }}
          title="Delete"
        >
          {/* <i className="material-icons">&#xE872;</i> */}
          {/* <Icon icon="ic:baseline-delete" color="#7c0e0e" height="25" /> */}
        </button>
      </>
    ),
  },
];
const DELIVERYBOYCOLUMNS = ({ view, edit, _delete, covidmodel }) => [
  {
    header: "No.",
    Footer: "Id",
    accessorKey: "_id",
    disableFilters: true,
    sticky: "left",
    cell: ({ row }) => {
      //console.log({ row });
      return <div style={{ justifyContent: "right" }}>{row.index + 1}</div>;
    },
  },

  {
    header: "Name",
    accessorKey: "name",
  },
  {
    header: "City",
    accessorKey: "city",
  },
  {
    header: "Zipcode",
    accessorKey: "zipcode",
    // cell: ({ row }) => {
    //   console.log("test  1", row);
    //   console.log("test  ", row.original.zipcodes[0].zipcode);
    //   return (
    //     <div style={{ justifyContent: "right" }}>
    //       {row.original.zipcodes[0].zipcode}
    //     </div>
    //   );
    // },
  },
  {
    header: "Duty Status",
    accessorKey: "dutyStatus",
    cell: ({ row }) => (row.values.dutyStatus ? "On Duty" : "Off Duty"),
  },
  {
    header: "Contact",
    accessorKey: "mobileNumber",
  },
  {
    header: "Date Of Join",
    accessorKey: "createdDate",
    // className: "text-center",
    cell: ({ row }) => {
      console.log({ row });
      console.log(row.original.createdAt);

      return (
        // console.log(row.original.deliverySlot.from )

        <Moment format="DD MMM, YYYY HH:mm">{row.original.createdAt}</Moment>
      );
    },
  },
  {
    header: "Status",
    accessorKey: "isActive",
    cell: ({ row }) => (row.values.isActive ? "Activated" : "Deactivated"),
  },
  {
    header: "Covid",
    accessorKey: "covid",
    cell: (row) => (
      <button
        theme="white"
        onClick={() => covidmodel(row)}
        title="Covid report"
      >
        {/* <Icon icon="fa-solid:file-medical" color="#7c0e0e" height="25" /> */}
      </button>
    ),
  },
  {
    header: "Manager",
    accessorKey: "managerName",
  },
  {
    header: "Job Role",
    accessorKey: "isFreelancer",
    cell: ({ row }) => (row.values.isFreelancer ? "Freelancer" : "Normal"),
  },
  {
    header: "Vehicle",
    accessorKey: "vehicle",
  },
  // {
  //   header: "Approved",
  //   accessorKey: "staus",
  // },

  {
    header: "Actions",
    accessorKey: "actions",
    // maxWidth: 200,
    // minWidth: 180,
    sortable: false,
    cell: (row) => (
      <>
        <button theme="white" onClick={() => edit(row)} title="Edit">
          <i className="material-icons">&#xE254;</i>
          {/* <Icon icon="bx:bx-edit" color="#7c0e0e" height="25" /> */}
        </button>
        <button
          theme="white"
          onClick={() => {
            confirmAlert({
              title: message.ALERT,
              message: message.DELETE_CONFIRMATION,
              buttons: [
                {
                  label: "Confirm",
                  onClick: () => {
                    _delete(row);
                  },
                },
                {
                  label: "Cancel",
                  onClick: () => {
                    return false;
                  },
                },
              ],
            });
          }}
          title="Delete"
        >
          <i className="material-icons">&#xE872;</i>
          {/* <Icon icon="ic:baseline-delete" color="#7c0e0e" height="25" /> */}
        </button>
      </>
    ),
  },
];

const NEWREGISTEREDDBOYCOLUMNS = ( view, edit, _delete ) => [
  {
    header: "No.",
    Footer: "Id",
    accessorKey: "_id",
    disableFilters: true,
    sticky: "left",
    cell: ({ row }) => {
      //console.log({ row });
      return <div style={{ justifyContent: "right" }}>{row.index + 1}</div>;
    },
  },

  {
    header: "Name",
    accessorKey: "countryId",
  },
  {
    header: "City",
    accessorKey: "stateId",
  },
  {
    header: "Zipcode",
    accessorKey: "cityId",
    className: "text-center",
  },
  {
    header: "Contact No.",
    accessorKey: "state",
  },
  {
    header: "Applied Date",
    accessorKey: "city",
    className: "text-center",
  },
  {
    header: "Vehicle ",
    accessorKey: "zipcode",
  },
  {
    header: "Documents",
    accessorKey: "contactno",
  },
  {
    header: "Verify",
    accessorKey: "contactno",
  },
  {
    header: "Actions",
    accessorKey: "contactno",
  },
  {
    header: "Actions",
    accessorKey: "actions",
    maxWidth: 200,
    minWidth: 180,
    sortable: false,
    cell: (row) => (
      <>
        <button theme="white" onClick={() => edit(row)} title="Edit">
          <i className="material-icons">&#xE254;</i>
          {/* <Icon icon="bx:bx-edit" color="#7c0e0e" height="25" /> */}
        </button>
        <button
          theme="white"
          onClick={() => {
            confirmAlert({
              title: message.ALERT,
              message: message.DELETE_CONFIRMATION,
              buttons: [
                {
                  label: "Confirm",
                  onClick: () => {
                    _delete(row);
                  },
                },
                {
                  label: "Cancel",
                  onClick: () => {
                    return false;
                  },
                },
              ],
            });
          }}
          title="Delete"
        >
          <i className="material-icons">&#xE872;</i>
          {/* <Icon icon="ic:baseline-delete" color="#7c0e0e" height="25" /> */}
        </button>
      </>
    ),
  },
];

const VEHICLECOLUMNS = ( view, edit, _delete ) => [
  {
    header: "No.",
    Footer: "Id",
    accessorKey: "_id",
    disableFilters: true,
    sticky: "left",
    cell: ({ row }) => {
      //console.log({ row });
      return <div style={{ justifyContent: "right" }}>{row.index + 1}</div>;
    },
  },
  {
    header: "Code",
    accessorKey: "vehicleNumber",
  },
  {
    header: "Type",
    accessorKey: "vehicleType",
  },
  {
    Header: "Brand",
    accessorKey: "vehicleBrand",
    className: "text-center",
  },
  {
    Header: "Model",
    accessorKey: "modelName",
  },
  {
    Header: "Year",
    accessorKey: "makeYear",
  },
  {
    Header: "Vehicle Insuarance",
    accessorKey: "vehicleInsuarance",
    cell: ({ row }) => (row.original.vehicleInsuarance ? "Yes" : "No"),
  },
  {
    Header: "Actions",
    accessorKey: "actions",
    // maxWidth: 200,
    // minWidth: 180,
    sortable: false,
    cell: (row) => (
      <>
        {/* <button
          theme="white"
          onClick={() => view(row)}
          title="Active and Deactive"
        >
          <Icon icon="carbon:view-filled" color="#7c0e0e" height="25" />
        </button> */}
        <button theme="white" onClick={() => edit(row)} title="Edit">
          <i className="material-icons">&#xE254;</i>
          {/* <Icon icon="bx:bx-edit" color="#7c0e0e" height="25" /> */}
        </button>
        <button
          theme="white"
          onClick={() => {
            confirmAlert({
              title: message.ALERT,
              message: message.DELETE_CONFIRMATION,
              buttons: [
                {
                  label: "Confirm",
                  onClick: () => {
                    _delete(row);
                  },
                },
                {
                  label: "Cancel",
                  onClick: () => {
                    return false;
                  },
                },
              ],
            });
          }}
          title="Delete"
        >
          <i className="material-icons">&#xE872;</i>
          {/* <Icon icon="ic:baseline-delete" color="#7c0e0e" height="25" /> */}
        </button>
      </>
    ),
  },
];
const DROPPOINTCOLUMNS = ( view, edit, _delete ) => [
  {
    header: "No.",
    Footer: "Id",
    accessorKey: "_id",
    disableFilters: true,
    sticky: "left",
    cell: ({ row }) => {
      console.log({ row });
      return <div style={{ justifyContent: "right" }}>{row.index + 1}</div>;
    },
  },

  {
    header: "Shop Name",
    accessorKey: "shopName",
  },
  {
    header: "Contact Person",
    accessorKey: "contactPerson",
  },
  {
    header: "Contact No.",
    accessorKey: "phoneNo",
    className: "text-center",
  },
  {
    header: "Address",
    accessorKey: "address",
  },
  {
    header: "City",
    accessorKey: "city",
    className: "text-center",
  },
  {
    header: "Zipcode",
    accessorKey: "zipcode",
  },
  {
    header: "UserID",
    accessorKey: "userId",
  },
  {
    header: "Manager",
    accessorKey: "manager",
  },
  {
    header: "Actions",
    accessorKey: "actions",
    maxWidth: 200,
    minWidth: 180,
    sortable: false,
    cell: (row) => (
      <>
        <button
          theme="white"
          onClick={() => view(row)}
          title="Active and Deactive"
        >
          <i className="material-icons">&#xE5CA;</i>
          {/* <Icon icon="carbon:view-filled" color="#7c0e0e" height="25" /> */}
        </button>
        <button theme="white" onClick={() => edit(row)} title="Edit">
          <i className="material-icons">&#xE254;</i>
          {/* <Icon icon="bx:bx-edit" color="#7c0e0e" height="25" /> */}
        </button>
        <button theme="white" onClick={() => _delete(row)} title="Delete">
          <i className="material-icons">&#xE872;</i>
          {/* <Icon icon="ic:baseline-delete" color="#7c0e0e" height="25" /> */}
        </button>
      </>
    ),
  },
];
export {
  columnDefDefaultFn,
  OutBoxColumnDefDefaultFn,
  ProductColumnDefDefaultFn,
  LinkedOrderColumnDef,
  StockColumnDefDefaultFn,
  TrfColumnDefDefaultFn,
  TrfAllUserColumnDefDefaultFn,
  ProductColumnforViewOutboxOrder,
  ProcessLossColumnDef,
  TrfUserColumnDefDefaultFn,
  ProductColumnDefForeReviewOrder,
  columnDeliveryboy,
  ASSIGNEDORDERCOLUMNS,
  MANAGERCOLUMNS,
  NEWREGISTEREDDBOYCOLUMNS,
  VEHICLECOLUMNS,
  DROPPOINTCOLUMNS
};
